import Environment from "@shared/environment";
import HttpClient from "@shared/services/http-client.service";
import LoggerService from "@shared/services/logger.service";
export var PhotoType;
(function (PhotoType) {
    PhotoType[PhotoType["Avatar"] = 0] = "Avatar";
    PhotoType[PhotoType["MarketplaceCover"] = 1] = "MarketplaceCover";
    PhotoType[PhotoType["CoachingGroup"] = 2] = "CoachingGroup";
})(PhotoType || (PhotoType = {}));
var PhotoUploaderService = /** @class */ (function () {
    function PhotoUploaderService() {
        this.httpClient = new HttpClient();
        this.logger = new LoggerService();
        this.photoUrl = Environment.vdotAppUrl + "/webapi/photo";
    }
    PhotoUploaderService.prototype.uploadPhoto = function (photoType, imageData, fileName) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var self = _this;
            var url = _this.photoUrl + "?type=" + photoType;
            var input = new FormData();
            input.append("image", imageData, fileName);
            _this.httpClient
                .post(url, input)
                .then(function (response) { resolve(response.data); })
                .catch(function (e) { return self.httpClient.defaultErrorHandler(reject, e); });
        });
    };
    PhotoUploaderService.prototype.deletePhoto = function (photoType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var self = _this;
            var url = _this.photoUrl + "?type=" + photoType;
            _this.httpClient
                .delete(url)
                .then(function (response) { resolve(response.data); })
                .catch(function (e) { return self.httpClient.defaultErrorHandler(reject, e); });
        });
    };
    return PhotoUploaderService;
}());
export { PhotoUploaderService };
export default PhotoUploaderService;



//////////////////
// WEBPACK FOOTER
// ./app/shared/services/photo-uploader.service.ts
// module id = 82
// module chunks = 3 4